import { __decorate, __metadata } from "tslib";
import { Guid } from 'guid-typescript';
import { VuexModule, Module, getModule, Action, Mutation, } from 'vuex-module-decorators';
import { plainToClass } from 'class-transformer';
import TemplateStage, { ITemplateStage } from '../models/engagements/templateStage';
import TemplateActivity from '../models/engagements/templateActivity';
import store from '@/store';
import service from '../../services/api.service';
import { getTenantId } from '@/store/helper';
let TemplatesModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    let TemplatesModule = class TemplatesModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.template = [];
            this.apiNode = 'template';
        }
        // ACTIONS
        async GetTemplateStages() {
            var url = `${getTenantId()}/${this.apiNode}/stages`;
            let { data } = await service.get(url);
            if (data) {
                this.SetTemplateStages(plainToClass(TemplateStage, data.templateStages));
                return data;
            }
        }
        async SaveTemplateStage(templateStageDetails) {
            var url = `${getTenantId()}/${this.apiNode}/templateStage`;
            let { data } = await service.post(url, templateStageDetails);
            if (data) {
                this.AddOrEditTemplateStage(plainToClass(TemplateStage, data.templateStage));
                return data;
            }
        }
        async SaveTemplateActivity(templateActivityDetails) {
            var url = `${getTenantId()}/${this.apiNode}/templateStage/` + templateActivityDetails[0] + `/templateActivity`;
            let { data } = await service.post(url, templateActivityDetails[1]);
            if (data) {
                this.AddOrEditActivityInStage([
                    templateActivityDetails[0],
                    templateActivityDetails[1],
                    plainToClass(TemplateActivity, data.templateActivity),
                ]);
                return data;
            }
        }
        async DeleteTemplateStage(stageId) {
            var url = `${getTenantId()}/${this.apiNode}/stage/` + stageId;
            let { data } = await service.delete(url);
            if (data) {
                this.DeleteStageFromTemplateStage(data.stageId);
                return data;
            }
        }
        async DeleteTemplateActivity(activityId) {
            var url = `${getTenantId()}/${this.apiNode}/activity/` + activityId;
            let { data } = await service.delete(url);
            if (data) {
                this.DeleteActivityFromTemplateStage(data.activityId);
                return data;
            }
        }
        // MUTATIONS
        SetTemplateStages(configurations) {
            this.template = configurations;
        }
        AddOrEditTemplateStage(templateStage) {
            var theStage = templateStage;
            var existingStage = this.template.find((x) => x.id === theStage.id);
            if (existingStage === null || existingStage === undefined) {
                theStage.activities = [];
                this.template.push(theStage);
            }
            else {
                existingStage.stageName = theStage.stageName;
                existingStage.isTenantVisible = theStage.isTenantVisible;
                existingStage.description = theStage.description;
            }
        }
        DeleteActivityFromTemplateStage(activityId) {
            var stage = this.template.find((x) => x.activities.find((x) => x.activityId == activityId));
            const index = stage.activities
                .map(function (array) {
                return array.activityId;
            })
                .indexOf(activityId, 0);
            if (index > -1) {
                stage.activities.splice(index, 1);
            }
        }
        AddOrEditActivityInStage(engagementActivity) {
            var currentStage = this.template.find((x) => x.id == engagementActivity[0]);
            var existingActivity = currentStage.activities.find((x) => x.activityId == engagementActivity[1].activityId);
            if (existingActivity === null || existingActivity === undefined) {
                currentStage.activities.push(engagementActivity[1]);
            }
            else {
                existingActivity.activityDesc = engagementActivity[1].activityDesc;
                existingActivity.isTenantVisible = engagementActivity[1].isTenantVisible;
                existingActivity.baseline = engagementActivity[1].baseline;
                existingActivity.threshold = engagementActivity[1].threshold;
            }
        }
        DeleteStageFromTemplateStage(stageId) {
            const index = this.template
                .map(function (array) {
                return array.id;
            })
                .indexOf(stageId, 0);
            if (index > -1) {
                var stage = this.template.splice(index, 1);
            }
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], TemplatesModule.prototype, "GetTemplateStages", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof ITemplateStage !== "undefined" && ITemplateStage) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], TemplatesModule.prototype, "SaveTemplateStage", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], TemplatesModule.prototype, "SaveTemplateActivity", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof Guid !== "undefined" && Guid) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], TemplatesModule.prototype, "DeleteTemplateStage", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof Guid !== "undefined" && Guid) === "function" ? _g : Object]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], TemplatesModule.prototype, "DeleteTemplateActivity", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], TemplatesModule.prototype, "SetTemplateStages", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TemplatesModule.prototype, "AddOrEditTemplateStage", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof Guid !== "undefined" && Guid) === "function" ? _j : Object]),
        __metadata("design:returntype", void 0)
    ], TemplatesModule.prototype, "DeleteActivityFromTemplateStage", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TemplatesModule.prototype, "AddOrEditActivityInStage", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof Guid !== "undefined" && Guid) === "function" ? _k : Object]),
        __metadata("design:returntype", void 0)
    ], TemplatesModule.prototype, "DeleteStageFromTemplateStage", null);
    TemplatesModule = __decorate([
        Module({ dynamic: true, store: store, name: 'templates', namespaced: true })
    ], TemplatesModule);
    return TemplatesModule;
})();
export default getModule(TemplatesModule);
